import * as THREE from 'three';

export default class SkyboxManager {
    constructor(scene) {
        this.scene = scene;
    }
    
    createSkybox() {
        // Enhanced gradient skybox
        const vertexShader = `
        varying vec3 vWorldPosition;
        void main() {
            vec4 worldPosition = modelMatrix * vec4(position, 1.0);
            vWorldPosition = worldPosition.xyz;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
        `;
        
        const fragmentShader = `
        uniform vec3 topColor;
        uniform vec3 middleColor;
        uniform vec3 bottomColor;
        uniform float offset;
        uniform float exponent;
        varying vec3 vWorldPosition;
        void main() {
            float h = normalize(vWorldPosition + offset).y;
            vec3 skyColor;
            
            // Three-color gradient for more realistic sky
            if (h > 0.2) {
                // Blend between top and middle
                float t = (h - 0.2) / 0.8;
                skyColor = mix(middleColor, topColor, pow(t, exponent));
            } else {
                // Blend between middle and bottom
                float t = h / 0.2;
                skyColor = mix(bottomColor, middleColor, pow(t, exponent));
            }
            
            gl_FragColor = vec4(skyColor, 1.0);
        }
        `;
        
        const uniforms = {
            topColor: { value: new THREE.Color(0x1A2F7A) },    // Brighter deep blue for top of sky
            middleColor: { value: new THREE.Color(0x7FBAEA) }, // Brighter sky blue for middle
            bottomColor: { value: new THREE.Color(0xF0EFE0) }, // Brighter warm light color near horizon
            offset: { value: 20 },
            exponent: { value: 0.4 }
        };
        
        const skyGeo = new THREE.SphereGeometry(5000, 32, 15);
        const skyMat = new THREE.ShaderMaterial({
            uniforms: uniforms,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            side: THREE.BackSide
        });
        
        const sky = new THREE.Mesh(skyGeo, skyMat);
        this.scene.add(sky);
        
        return sky;
    }
    
    addClouds() {
        // Create several cloud planes at different heights and positions
        const cloudTexture = new THREE.TextureLoader().load('/cloud.png');
        const cloudMaterial = new THREE.MeshBasicMaterial({
            map: cloudTexture,
            transparent: true,
            opacity: 0.7,
            side: THREE.DoubleSide,
            depthWrite: false
        });
        
        // We'll create cloud planes even if the texture isn't loaded yet
        const planeGeometry = new THREE.PlaneGeometry(200, 200);
        
        const clouds = [];
        
        // Create several clouds at different positions and rotations
        for (let i = 0; i < 10; i++) {
            const cloud = new THREE.Mesh(planeGeometry, cloudMaterial);
            
            // Random position high in the sky
            const x = (Math.random() - 0.5) * 500;
            const y = 100 + Math.random() * 100;
            const z = (Math.random() - 0.5) * 500;
            
            cloud.position.set(x, y, z);
            cloud.rotation.x = Math.PI / 2; // Make it horizontal
            
            // Random rotation around Y axis
            cloud.rotation.z = Math.random() * Math.PI * 2;
            
            // Random scale
            const scale = 1 + Math.random() * 2;
            cloud.scale.set(scale, scale, 1);
            
            // Assign clouds to layer 2 (layer 1 is the default layer)
            cloud.layers.set(2);
            
            this.scene.add(cloud);
            clouds.push(cloud);
        }
        
        return clouds;
    }
}